import { prepareCommonFiltersForApi } from "modules/common";
import { UUID } from "utils";

import { WorkflowFilters } from "../../models";

export function prepareFiltersForApi(
  filters?: Partial<WorkflowFilters>,
  customerSelectionId?: UUID | UUID[]
) {
  const param = prepareCommonFiltersForApi(filters);

  if (customerSelectionId) {
    param["customerId"] = filters?.customerId
      ? filters.customerId.concat(customerSelectionId)
      : customerSelectionId;
  }

  return param;
}
